<script lang="ts">
    export let day: number | undefined;
    export let month: number | undefined;
    export let year: number | undefined;

    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    const formatMonth = (month: number | undefined): string | undefined => {
        return month !== undefined && month >= 1 && month <= 12
            ? monthNames[month - 1]
            : undefined;
    };

    const formatDate = (
        day: number | undefined,
        month: number | undefined,
        year: number | undefined
    ): string => {
        const formattedMonth = formatMonth(month);

        if (formattedMonth && day !== undefined && year !== undefined) {
            return `${formattedMonth} ${day}, ${year}`;
        } else if (formattedMonth && day !== undefined) {
            return `${formattedMonth} ${day}`;
        } else if (formattedMonth && year !== undefined) {
            return `${formattedMonth}, ${year}`;
        } else if (formattedMonth) {
            return `${formattedMonth}`;
        } else if (year !== undefined) {
            return `${year}`;
        }
        return "";
    };

    $: answerText = formatDate(day, month, year);
</script>

<span class="gw-rv-attributes-answers__date">
    {answerText}
</span>

<style lang="postcss">
    .gw-rv-attributes-answers__date {
        font-size: 0.875em;
        font-weight: 400;
    }
</style>
